import React from "react";
import { fmtPrice } from "./PriceRange";

interface Props {
  min: number;
  max: number;
}

const PriceLegend: React.FC<Props> = ({ min, max }) => (
  <div className="pointer-events-auto min-h-20 py-4 bg-[#002412]/40 backdrop-blur-sm border border-white/30 rounded-xl overflow-hidden text-white [box-shadow:0_25px_50px_-12px_rgba(0,0,0,0.25),inset_4px_4px_14px_rgba(0,0,0,0.3),1px_1px_1px_rgba(255,255,255,0.14)]">
    <p className="px-4 text-md font-bold text-center leading-none">Precio promedio por m²</p>
    <div className="flex items-center gap-3 px-4">
      <div className="shrink-0 text-left">
        <p className="text-[10px] text-white/50">Bajo</p>
        <p className="text-xs font-medium">{fmtPrice(min)}</p>
      </div>
      <div
        className="flex-1 h-3 rounded-full"
        style={{ background: "linear-gradient(to right, #001a0d, #05EE84)" }}
      />
      <div className="shrink-0 text-right">
        <p className="text-[10px] text-white/50">Alto</p>
        <p className="text-xs font-medium">{fmtPrice(max)}</p>
      </div>
    </div>
  </div>
);

export default PriceLegend;
